import { Form, FormProps, Input, InputNumber, Modal, ModalProps } from "antd";
import { useEffect } from "react";

export const ModalDeleteMultipleChapter: React.FC<{
  modalProps: ModalProps;
  formProps: FormProps;
  bookId: string;
}> = ({ modalProps, formProps, bookId }) => {
  useEffect(() => {
    formProps.form?.setFieldsValue({
      bookId,
    });
  }, [bookId, formProps.form]);

  return (
    <Modal
      {...modalProps}
      centered
      width={480}
      title={"Xóa nhiều chapter"}
      destroyOnClose
    >
      <Form {...formProps} layout="vertical">
        <Form.Item name="bookId" hidden>
          <Input />
        </Form.Item>
        <Form.Item
          label="Từ số"
          name="from"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập không để trống",
            },
          ]}
        >
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>
        <Form.Item
          label="Đến số"
          name="to"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập không để trống",
            },
          ]}
        >
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
